module.exports = __webpack_public_path__ + "static/media/muted.07806d6a.svg";